import {
  InjectionKey,
  MaybeRef,
  Ref,
  computed,
  hasInjectionContext,
  inject,
  unref,
} from 'vue';
import { Maybe } from '@/src/types';
import {
  defaultModelMetadata,
  useModelStore,
} from '@/src/store/datasets-models';
// import { useLayersStore } from '@/src/store/datasets-layers';
// import { createLPSBounds, getAxisBounds } from '@/src/utils/lps';
import { useDatasetStore } from '@/src/store/datasets';
import { storeToRefs } from 'pinia';

export interface CurrentModelContext {
  modelID: Ref<Maybe<string>>;
}

export const CurrentModelInjectionKey = Symbol(
  'CurrentModel'
) as InjectionKey<CurrentModelContext>;

// Returns a spatially inflated image extent
// export function getImageSpatialExtent(imageID: Maybe<string>) {
//   const imageStore = useImageStore();

//   if (imageID && imageID in imageStore.metadata) {
//     const { lpsOrientation } = imageStore.metadata[imageID];
//     const image = imageStore.dataIndex[imageID];
//     if (image) {
//       const extent = image.getSpatialExtent();
//       return {
//         Sagittal: getAxisBounds(extent, 'Sagittal', lpsOrientation),
//         Coronal: getAxisBounds(extent, 'Coronal', lpsOrientation),
//         Axial: getAxisBounds(extent, 'Axial', lpsOrientation),
//       };
//     }
//   }
//   return createLPSBounds();
// }

export function getModelMetadata(modelID: Maybe<string>) {
  const { metadata } = useModelStore();
  if (!modelID) return defaultModelMetadata();
  return metadata[modelID] ?? defaultModelMetadata();
}

export function getPolyData(modelID: Maybe<string>) {
  const { dataIndex } = useModelStore();
  return modelID ? dataIndex[modelID] ?? null : null;
}

export function getIsModelLoading(modelID: Maybe<string>) {
  if (!modelID) return false;
  const modelStore = useModelStore();
  return !modelStore.dataIndex[modelID];
}

// export function getImageLayers(modelID: Maybe<string>) {
//   if (!imageID) return [];
//   const layersStore = useLayersStore();
//   return layersStore
//     .getLayers(imageID)
//     .filter(({ id }) => id in layersStore.layerImages);
// }

export function useModel(modelID: MaybeRef<Maybe<string>>) {
  return {
    id: computed(() => unref(modelID)),
    polydata: computed(() => getPolyData(unref(modelID))),
    metadata: computed(() => getModelMetadata(unref(modelID))),
    // extent: computed(() => getImageSpatialExtent(unref(modelID))),
    isLoading: computed(() => getIsModelLoading(unref(modelID))),
    // layers: computed(() => getImageLayers(unref(modelID))),
  };
}

export function useCurrentModel() {
  const { primaryImageID } = storeToRefs(useDatasetStore());
  const defaultContext = { modelID: primaryImageID };

  //nimps
  const { modelID } = hasInjectionContext() ? inject(CurrentModelInjectionKey, defaultContext) : defaultContext;

  // return {
  //   id: computed(() => unref(modelID)),
  //   polydata: computed(() => getPolyData(unref(modelID))),
  //   metadata: computed(() => getModelMetadata(unref(modelID))),
  //   // extent: computed(() => getImageSpatialExtent(unref(modelID))),
  //   isLoading: computed(() => getIsModelLoading(unref(modelID))),
  //   // layers: computed(() => getImageLayers(unref(modelID))),
  // };
}
